import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { ErrorStatePageError } from 'ui/illustrations';
import { TextButton } from 'ui/button';
import { spacing, link } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { BrandAffinityBackground } from 'modules/intelligentInsights/brandAffinityInsights/components/layout/BrandAffinity.styles';

const Wrapper = styled.div`
  padding: ${spacing.x12} 0;
`;

const DescriptionWrapper = styled.span`
  max-width: ${pxToRem(460)};
`;

const ErrorLinkText = styled(TextButton)`
  ${link};
  padding: 0;
  cursor: pointer;
`;

export const BrandAffiityErrorId = 'brand-affinity-error';

export const BrandAffinityError = () => (
  <BrandAffinityBackground>
    <Wrapper data-test={BrandAffiityErrorId}>
      <EmptyState
        Illustration={ErrorStatePageError}
        title="Oops!"
        subtitle={
          <DescriptionWrapper>
            We had a problem fetching this page.{' '}
            <ErrorLinkText onClick={() => window.location.reload()}>Click here</ErrorLinkText> to go
            back and try again.
          </DescriptionWrapper>
        }
      />
    </Wrapper>
  </BrandAffinityBackground>
);
